const MAX_DIMENSION = 2000;

export async function convertFileToJpegDataUrl(
  file: File,
  quality = 0.9
): Promise<{ dataUrl: string; filename: string }> {
  const originalUrl = URL.createObjectURL(file);
  try {
    const image = await loadImage(originalUrl);
    const { width, height } = scaleDimensions(image.naturalWidth, image.naturalHeight);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas 2D context unavailable");

    // JPEG has no alpha channel — fill transparent pixels with white so PNGs
    // don't render as black.
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(image, 0, 0, width, height);

    const dataUrl = canvas.toDataURL("image/jpeg", quality);
    const baseName = file.name.replace(/\.[^.]+$/, "") || "inspiration";
    return { dataUrl, filename: `${baseName}.jpg` };
  } finally {
    URL.revokeObjectURL(originalUrl);
  }
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function scaleDimensions(width: number, height: number) {
  if (width <= MAX_DIMENSION && height <= MAX_DIMENSION) {
    return { width, height };
  }
  const ratio = width / height;
  if (width >= height) {
    return { width: MAX_DIMENSION, height: Math.round(MAX_DIMENSION / ratio) };
  }
  return { width: Math.round(MAX_DIMENSION * ratio), height: MAX_DIMENSION };
}
